import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
const Pencil = ({ style })=>{
    return /*#__PURE__*/ _jsx("div", {
        style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: style.lineHeight,
            height: style.lineHeight
        },
        children: /*#__PURE__*/ _jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: style.fontSize,
            height: style.fontSize,
            viewBox: "0 0 16 16",
            style: {
                transform: "scale(0.75)"
            },
            children: [
                /*#__PURE__*/ _jsx("title", {
                    children: "pen"
                }),
                /*#__PURE__*/ _jsxs("g", {
                    fill: "currentColor",
                    children: [
                        /*#__PURE__*/ _jsx("path", {
                            d: "M8.616,2.677,1.646,9.646a.5.5,0,0,0-.128.222l-1.5,5.5a.5.5,0,0,0,.614.614l5.5-1.5a.5.5,0,0,0,.222-.128l6.969-6.97Z",
                            fill: "currentColor"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            "data-color": "color-2",
                            d: "M15.561,3.025,12.975.439a1.5,1.5,0,0,0-2.121,0L9.677,1.616l4.707,4.707,1.177-1.177A1.5,1.5,0,0,0,15.561,3.025Z"
                        })
                    ]
                })
            ]
        })
    });
};
export default Pencil;
